import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";
import moment from 'moment';

export function getCashAccounts(context) {  //20250213
    const {
        cashaccounts,
        reconciliations,
        currencies,
        exchangerates,
    } = context;

    const generalledgerdata = getGeneralLedgerData(context);
    let filteredledgerdata = generalledgerdata
        .filter(data => data.accounttype == 'cashaccounts')

    const data = [];
    cashaccounts.forEach((account) => {
        let accountledgers = filteredledgerdata
            .filter(data => data.accountid == account.id)

        let reconciliationdate = ''
        let cashreconciliations = reconciliations
            .filter(data => data.accounttype == 'cashaccounts' && data.accountid == account.id)
            .sort((a, b) => b.ts - a.ts)[0]
        if (cashreconciliations) {
            reconciliationdate = moment.unix(cashreconciliations.ts).format("D/MMM/YYYY");
        }

        let currencysymbol = currencies.find(curr => curr.id == account.currencyid)?.symbol

        data.push({
            ...account,
            currencysymbol: currencysymbol,
            balance: -getledgerbalance(accountledgers, exchangerates, account.currencyid),
            reconciled: reconciliationdate
        });
    });

    data.sort((a, b) => a.name.localeCompare(b.name));
    return data;
}
